import type { ChipTone } from "../../../ui/styles/chipStyles";

/** How an agent turn or a tool turn ended, as a chip tone; the same for both kinds of turn. */
export const TURN_OUTCOME_TONE: Readonly<Record<"completed" | "failed" | "cancelled", ChipTone>> = {
  completed: "success",
  failed: "danger",
  cancelled: "warning",
};
